import { lazy } from 'react';

export const TrustedDevicesPage = lazy(() =>
  import('@/app/administration/pages/settings/TrustedDevicesPage').then((m) => ({ default: m.TrustedDevicesPage }))
);

export const ActiveSessionsPage = lazy(() =>
  import('@/app/administration/pages/settings/ActiveSessionsPage').then((m) => ({ default: m.ActiveSessionsPage }))
);

export const RetentionPage = lazy(() =>
  import('@/app/administration/pages/settings/RetentionPage').then((m) => ({ default: m.RetentionPage }))
);

export const BackupExportPage = lazy(() =>
  import('@/app/administration/pages/settings/BackupExportPage').then((m) => ({ default: m.BackupExportPage }))
);

export const ExchangeRunnerPage = lazy(() =>
  import('@/app/administration/pages/settings/ExchangeRunnerPage').then((m) => ({ default: m.ExchangeRunnerPage }))
);

export const OperationsDashboardPage = lazy(
  () => import('@/app/administration/pages/OperationsDashboardPage')
);

// Admin & Cross-cutting
export const GlobalSearch = lazy(() =>
  import('@/app/administration/pages/GlobalSearch').then((m) => ({ default: m.GlobalSearch }))
);

export const AuditLog = lazy(() => import('@/app/administration/pages/AuditLogV2'));

export const WorkspaceDetailsPage = lazy(() =>
  import('@/app/administration/pages/settings/WorkspaceDetailsPage').then((m) => ({
    default: m.WorkspaceDetailsPage,
  }))
);

export const ApiAccessPage = lazy(() =>
  import('@/app/administration/pages/settings/ApiAccessPage').then((m) => ({ default: m.ApiAccessPage }))
);

export const TicketAttentionPolicyPage = lazy(() =>
  import('@/app/administration/pages/settings/TicketAttentionPolicyPage').then((m) => ({
    default: m.TicketAttentionPolicyPage,
  }))
);

export const PersonalProfilePage = lazy(() =>
  import('@/app/administration/pages/settings/PersonalProfilePage').then((m) => ({
    default: m.PersonalProfilePage,
  }))
);

// V3 integrations: catalog + per-tenant configs from /settings/integrations/*.
// IntegrationsV2 was a combined Integrations + Staff thin tab; Staff is now
// its own destination at /settings/staff so V3 is integrations-only.
export const IntegrationsHub = lazy(() => import('@/app/administration/pages/Integrations'));

export const TenantConsent = lazy(() =>
  import('@/app/administration/pages/TenantConsent').then((m) => ({ default: m.TenantConsent }))
);

// QuickTools removed — god-page deleted
export const NotificationCenter = lazy(() =>
  import('@/app/administration/pages/NotificationCenter').then((m) => ({ default: m.NotificationCenter }))
);

export const HolidayCalendar = lazy(() =>
  import('@/app/administration/pages/HolidayCalendar').then((m) => ({ default: m.HolidayCalendar }))
);

export const TenantComparisonPage = lazy(() =>
  import('@/app/administration/pages/TenantComparisonPage').then((m) => ({ default: m.TenantComparisonPage }))
);

export const ReportHistory = lazy(() =>
  import('@/app/administration/pages/ReportHistory').then((m) => ({ default: m.ReportHistory }))
);

export const ReportSchedules = lazy(() =>
  import('@/app/administration/pages/ReportSchedules').then((m) => ({ default: m.ReportSchedules }))
);

export const ScanScheduleTemplates = lazy(() =>
  import('@/app/administration/pages/ScanScheduleTemplates').then((m) => ({ default: m.ScanScheduleTemplates }))
);

export const KBEditor = lazy(() =>
  import('@/app/administration/pages/KBEditor').then((m) => ({ default: m.KBEditor }))
);

export const TemplateHub = lazy(() =>
  import('@/app/administration/pages/TemplateHub').then((m) => ({ default: m.TemplateHub }))
);

export const NotificationPreferences = lazy(() =>
  import('@/app/administration/pages/NotificationPreferences').then((m) => ({
    default: m.NotificationPreferences,
  }))
);

export const EmailDeliveryLog = lazy(() =>
  import('@/app/administration/pages/EmailDeliveryLog').then((m) => ({ default: m.EmailDeliveryLog }))
);

export const SatisfactionSurveys = lazy(() =>
  import('@/app/administration/pages/SatisfactionSurveys').then((m) => ({ default: m.SatisfactionSurveys }))
);

export const BrandingConfig = lazy(() =>
  import('@/app/administration/pages/BrandingConfig').then((m) => ({ default: m.BrandingConfig }))
);

export const CapabilityRegistry = lazy(() =>
  import('@/app/administration/pages/CapabilityRegistry').then((m) => ({ default: m.CapabilityRegistry }))
);

export const NetworkAccessControl = lazy(() =>
  import('@/app/administration/pages/NetworkAccessControl').then((m) => ({ default: m.NetworkAccessControl }))
);

export const AITimeDefaults = lazy(() =>
  import('@/app/administration/pages/AITimeDefaults').then((m) => ({ default: m.AITimeDefaults }))
);

// ApiDocs removed — see external docs site
// FeaturesShowcase removed — demo page deleted
export const InsightsPage = lazy(() =>
  import('@/app/administration/pages/InsightsPage').then((m) => ({ default: m.InsightsPage }))
);

export const Webhooks = lazy(() =>
  import('@/app/administration/pages/Webhooks').then((m) => ({ default: m.Webhooks }))
);

export const EmailRoutingRules = lazy(() =>
  import('@/app/administration/pages/EmailRoutingRules').then((m) => ({ default: m.EmailRoutingRules }))
);

export const TicketWorkflows = lazy(() =>
  import('@/app/administration/pages/TicketWorkflows').then((m) => ({ default: m.TicketWorkflows }))
);

export const SettingsGeneralPage = lazy(() => import('@/app/administration/pages/settings/GeneralPage'));

export const SettingsIntegrationsPage = lazy(() => import('@/app/administration/pages/settings/IntegrationsPage'));

export const SettingsVaultPage = lazy(() => import('@/app/administration/pages/settings/VaultPage'));

export const SettingsStaffPage = lazy(() => import('@/app/administration/pages/settings/StaffAndPermissionsPage'));

export const SettingsPlatformPage = lazy(() => import('@/app/administration/pages/settings/PlatformPage'));

export const SettingsAIPage = lazy(() => import('@/app/administration/pages/settings/AIPage'));

// V3 cluster collapse 2026-04-30: absorbs /admin/notifications/preferences,
// /admin/email-routing, /admin/templates, /admin/notifications/delivery,
// /admin/notifications/surveys into a single tabbed parent.
export const CommunicationsHub = lazy(() =>
  import('@/app/administration/pages/settings/CommunicationsHub').then((m) => ({ default: m.CommunicationsHub }))
);

// Business hours SSOT — consumed by SLA "business hours only" toggle, Communications Migration
// auto-attendant defaults, Tenant Setup Configure phase. Backend at /business-hours.
export const BusinessHoursPage = lazy(() =>
  import('@/app/administration/pages/settings/BusinessHoursPage').then((m) => ({ default: m.BusinessHoursPage }))
);
